import React from "react";
import banner from "../../assets/projects/proposalautomation.png";
import ss1 from "../../assets/screenshots/dailybusinessreport/ss1.png"
import ss2 from "../../assets/screenshots/dailybusinessreport/ss2.png"
import ss3 from "../../assets/screenshots/dailybusinessreport/ss3.png"
import ss4 from "../../assets/screenshots/dailybusinessreport/ss4.png"
import ss5 from "../../assets/screenshots/dailybusinessreport/ss5.png"

const AIProposalAutomationSystemPage = () => (
  <main className="container mx-auto max-width pt-10 pb-20 space-y-16">
    
    {/* Banner Image */}
    <section className="w-full">
      <img
        src={banner}
        alt="AI Proposal Automation System Banner"
        className="w-[500px] rounded-xl shadow-md object-cover"
      />
    </section>

    {/* Project Title & Overview */}
    <section>
      <h1 className="text-4xl xl:text-5xl font-bold text-dark-heading dark:text-light-heading mb-4">
        AI Proposal Automation System
      </h1>
      <p className="text-lg text-content lg:max-w-4xl">
        AI Proposal Automation System is an AI-powered automation workflow that generates professional proposals automatically from user-submitted form data. Built using n8n, Jotform, Google Docs, Google Drive, Airtable, and OpenAI, the system collects proposal information through a form, generates structured proposal content using AI, creates a formatted document using a Google Docs template, converts the document into a PDF, and stores all data and files in Airtable and Google Drive. This automation eliminates repetitive manual proposal creation by turning a simple form submission into a fully generated proposal document and PDF that are automatically organized and stored.
      </p>
    </section>

  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      ▶️ Live Demo
    </h2>
    <div className="w-full aspect-video">
      <iframe
        className="w-full h-full rounded-lg shadow"
        src="https://www.youtube.com/embed/xNOONpmPRMw"
        title="AI Proposal Automation System Demo"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  </section>

    {/* Technology Stack */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        💻 Technology Stack
      </h2>
      <ul className="list-disc list-inside text-content space-y-2">
        <li><strong>n8n:</strong> Core automation engine that orchestrates the entire proposal generation workflow</li>
        <li><strong>Jotform:</strong> Collects proposal information submitted by users</li>
        <li><strong>OpenAI (GPT):</strong> Generates structured proposal content based on user input</li>
        <li><strong>Google Docs:</strong> Serves as the proposal template used to generate the final document</li>
        <li><strong>Google Drive:</strong> Stores the generated proposal documents and PDF files</li>
        <li><strong>Airtable:</strong> Central database that stores user inputs, generated proposal content, document links, and PDF files</li>
      </ul>
    </section>

    {/* Automation Features */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        ⚙️ Automation Workflow Features (n8n)
      </h2>
      <ul className="list-disc list-inside text-content space-y-2">
        <li>Triggers the automation when a user submits a proposal form through Jotform</li>
        <li>Processes all submitted proposal information as structured workflow data</li>
        <li>Generates proposal content automatically using an AI LLM chain powered by OpenAI</li>
        <li>Copies a Google Docs proposal template from Google Drive into a dedicated Proposal Automation folder</li>
        <li>Replaces template placeholders with AI-generated proposal content</li>
        <li>Creates a fully formatted proposal document</li>
        <li>Converts the generated proposal document into a PDF</li>
        <li>Uploads the generated PDF into the Proposal Automation folder in Google Drive</li>
        <li>Stores the entire proposal record in Airtable including user inputs, generated proposal content, Google Docs URL, and the PDF file</li>
      </ul>
    </section>

    {/* System Data Management */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        📊 Proposal Data & File Management
      </h2>
      <ul className="list-disc list-inside text-content space-y-2">
        <li>Stores all proposal submissions and generated data in Airtable</li>
        <li>Maintains a centralized record containing user inputs, AI-generated proposal sections, and file references</li>
        <li>Automatically links the generated Google Docs proposal to the Airtable record</li>
        <li>Attaches the final generated PDF file directly to the Airtable proposal entry</li>
        <li>Ensures all proposal files are organized and stored in a dedicated Google Drive folder</li>
      </ul>
    </section>

    {/* Screenshots */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
    🖼️ Project Images & Screenshots
      </h2>

      <div className="flex flex-col gap-6">
  <div>
        <p className="mb-2 font-medium">Key Features</p>
        <a href={banner} target="_blank" rel="noopener noreferrer">
          <img src={banner} alt="AI Product Data Enrichment Automation" className="w-full rounded-lg shadow" />
        </a>
      </div>
        {/* <div>
          <p className="mb-2 font-medium">Proposal Automation Workflow (n8n)</p>
          <a href={ss1} target="_blank" rel="noopener noreferrer">
            <img src={ss1} alt="Proposal Automation Workflow" className="w-full rounded-lg shadow" />
          </a>
        </div>

        <div>
          <p className="mb-2 font-medium">Jotform Proposal Submission Form</p>
          <a href={ss2} target="_blank" rel="noopener noreferrer">
            <img src={ss2} alt="Jotform Proposal Form" className="w-full rounded-lg shadow" />
          </a>
        </div>

        <div>
          <p className="mb-2 font-medium">Generated Proposal Document (Google Docs)</p>
          <a href={ss3} target="_blank" rel="noopener noreferrer">
            <img src={ss3} alt="Generated Proposal Document" className="w-full rounded-lg shadow" />
          </a>
        </div>

        <div>
          <p className="mb-2 font-medium">Airtable Proposal Database</p>
          <a href={ss4} target="_blank" rel="noopener noreferrer">
            <img src={ss4} alt="Airtable Proposal Database" className="w-full rounded-lg shadow" />
          </a>
        </div> */}

      </div>
    </section>

  </main>
);

export default AIProposalAutomationSystemPage;
